import { Box, Container } from '@mui/material';
import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactElement, useEffect, useMemo, useState } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { ArticleCardSlider } from '../../components/card-slider/article-card-slider/article-card-slider';
import { ROUTES } from '../../utils/routes';
import { articleSearchResultsSelector } from '../../store/articles-selectors';
import { fetchArticleSearchResult } from '../../store/articles-actions';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { useArticleDetailContext } from './article-detail';

export const ArticleDetailIdenticalProducts = (): ReactElement | null => {
    const dispatch = useAppDispatch();
    const { article } = useArticleDetailContext();
    const isMobile = useIsMobile();

    const [articlePage, setArticlePage] = useState(1);
    const searchParams = useMemo(
        () => new URLSearchParams({ [FilterParams.Search]: article.globalTradeItemNumber }),
        [article.globalTradeItemNumber]
    );

    const { searchResults, total } = useAppSelector(articleSearchResultsSelector);
    const filteredSearchResults = searchResults.filter(otherArticle => otherArticle.id !== article?.id);

    useEffect(() => {
        if (article.globalTradeItemNumber) {
            searchParams.set(FilterParams.Page, articlePage.toString());
            // Looked up by the page itself to show the same article from other
            // suppliers. Nobody searched for this number, and counting it would make
            // every product view look like a GTIN search.
            dispatch(fetchArticleSearchResult(searchParams, undefined, 'background'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [articlePage, dispatch, article.globalTradeItemNumber]);

    if (filteredSearchResults.length === 0 || !article.globalTradeItemNumber) {
        return null;
    }

    return (
        <Box sx={{ pt: { xs: 2, sm: 7 }, pb: 5, backgroundColor: theme => theme.palette.grey[100] }}>
            <Container maxWidth={isMobile ? 'sm' : 'xl'} style={{ padding: 0 }}>
                <ArticleCardSlider
                    title={<FormattedMessage id="app.article.detail.identicalArticles" />}
                    articles={filteredSearchResults}
                    totalItems={total - 1}
                    showAllUrl={{
                        pathname: ROUTES.searchPage,
                        search: new URLSearchParams({
                            [FilterParams.Search]: article.globalTradeItemNumber,
                        }).toString(),
                    }}
                    onLoadMore={() => setArticlePage(articlePage + 1)}
                />
            </Container>
        </Box>
    );
};
